module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Aarburg-1888abdc2759605033bb36d23bdec25d.svg";